import { useContext } from "react";
import { AuthContext, AuthContextType } from "@/context/AuthContext";

export const useHasAIAccess = () => {
  const { values: contextValues } = useContext(AuthContext) as AuthContextType;
  const { planDetails } = contextValues;
  return !!planDetails?.tenant_plan.has_ai_summary_access;
};
